module.exports = __webpack_public_path__ + "static/media/crown_touch1.9888a001.jpg";